var exports = {
  "k": "container__SV6DtN",
  "X": "pagination__CPT450",
};

module.exports = exports;
